import React from 'react'
import './styles.scss'
import { Image } from 'components/Image'

interface Props {
  content: textType[]
}

export const DioxinGraphic = ({ content }: Props) => (
  <div className='DioxinGraphic'>
    {content.map((seg, i) => {
      return (
        <div className={'seg s' + (i + 1)}>
          <div className='inner'>
            <div className='illu'>
              {/* <div className='ground' /> */}
              <Image
                src={seg.illu as string}
                annotations={seg.annotations}
                ground={seg.ground}
              />
            </div>
            <div className='text'>
              <div className='wrapper'>
                <div className='title'>{seg.title}</div>
                <div className='content'>{seg.text}</div>
              </div>
            </div>
          </div>
        </div>
      )
    })}
  </div>
)
